import { io } from "socket.io-client";
import axios from "axios";
import apiConfig from "../config/api.config";

const SOCKET_URL = apiConfig.baseUrl;
const API_URL = apiConfig.apiUrl;

let socket = null;
let statusCallbacks = [];
let qrCallbacks = [];
let messageCallbacks = [];

export function connectSocket() {
  // True singleton: reuse if socket exists and isn't fully disconnected
  if (socket && !socket.disconnected) return socket;

  // Clean up old socket if it exists but is disconnected
  if (socket) {
    socket.removeAllListeners();
    socket = null;
  }

  socket = io(SOCKET_URL, {
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 3000,
    reconnectionAttempts: 5,
  });

  socket.on("connect", () => {
    console.log("[WhatsApp Socket] Connected");
  });

  socket.on("whatsapp:status", (data) => {
    statusCallbacks.forEach((cb) => cb(data));
  });

  socket.on("whatsapp:qr", (data) => {
    qrCallbacks.forEach((cb) => cb(data));
  });

  socket.on("whatsapp:message", (data) => {
    messageCallbacks.forEach((cb) => cb(data));
  });

  socket.on("disconnect", () => {
    console.log("[WhatsApp Socket] Disconnected");
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  statusCallbacks = [];
  qrCallbacks = [];
  messageCallbacks = [];
}

export function onStatusChange(callback) {
  statusCallbacks.push(callback);
  return () => {
    statusCallbacks = statusCallbacks.filter((cb) => cb !== callback);
  };
}

export function onQRCode(callback) {
  qrCallbacks.push(callback);
  return () => {
    qrCallbacks = qrCallbacks.filter((cb) => cb !== callback);
  };
}

export function onMessage(callback) {
  messageCallbacks.push(callback);
  return () => {
    messageCallbacks = messageCallbacks.filter((cb) => cb !== callback);
  };
}

// REST API calls
export async function getWhatsAppStatus() {
  const { data } = await axios.get(`${API_URL}/whatsapp/status`);
  return data;
}

export async function sendWhatsAppMessage(phone, message) {
  const { data } = await axios.post(`${API_URL}/whatsapp/send`, {
    phone,
    message,
  });
  return data;
}

export async function sendWhatsAppPDF(carId, phone, currentKm) {
  const { data } = await axios.post(`${API_URL}/whatsapp/send-pdf/${carId}`, {
    phone,
    currentKm,
  });
  return data;
}

export async function sendWhatsAppHistory(carId, phone, currentKm) {
  const { data } = await axios.post(
    `${API_URL}/whatsapp/send-history/${carId}`,
    { phone, currentKm }
  );
  return data;
}

export async function sendByLicense(license, phone, currentKm, type = "text") {
  const { data } = await axios.post(`${API_URL}/whatsapp/send-by-license`, {
    license,
    phone,
    currentKm,
    type,
  });
  return data;
}

export async function disconnectWhatsApp() {
  const { data } = await axios.post(`${API_URL}/whatsapp/disconnect`);
  return data;
}

export async function reconnectWhatsApp() {
  const { data } = await axios.post(`${API_URL}/whatsapp/reconnect`);
  return data;
}
